// @ts-nocheck
const storage = window.localStorage;

/**
 * Where to reach the server.
 *
 * Was `process.env.NX_API_SOCKET_URL`, baked in by webpack and pointing at
 * `wss://qcloud.nextinq.com/qsrv/v1`. It now defaults to the same origin the
 * app was served from, which is what lets the cutover happen by DNS alone:
 * booths are unattended devices that cannot be told a new hostname, and the
 * server still answers on the legacy `/qsrv/v1` path.
 *
 * VITE_API_SOCKET_URL overrides it, for pointing a bench device at a laptop.
 */
function socketUrl(): string {
  const configured = import.meta.env.VITE_API_SOCKET_URL;
  if (configured) return configured;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/qsrv/v1`;
}

export interface AppSettings {
  boothId: string;
  boothSecret: string;
  notifications: string;
}

export const SETTINGS_KEYS = {
  APP_SETTINGS: 'APP_SETTINGS',
  getSecretKeyByUUID: (uuid) => `APP_SETTINGS.${uuid}.secret`
};

export function storeData(key, data) {
  return new Promise((resolve) => {
    const rawData = JSON.stringify(data);
    storage.setItem(key, rawData);
    resolve();
  });
}

export async function storeSecretByUUID(uuid, secret) {
  await storeData(SETTINGS_KEYS.getSecretKeyByUUID(uuid), secret);
}

function getData(key) {
  return new Promise((resolve) => {
    const rawResult = storage.getItem(key);
    let result = null;
    try {
      result = JSON.parse(rawResult);
      // eslint-disable-next-line no-empty
    } catch (e) {}
    resolve(result);
  });
}

/**
 * Whether an ID and secret have been entered. Without them the app never opens
 * the socket (app-init-saga), so "no queue found" means "not set up yet", not
 * a network problem.
 */
export function isProvisioned(): boolean {
  try {
    const settings = JSON.parse(storage.getItem(SETTINGS_KEYS.APP_SETTINGS) || 'null');
    return !!(settings && settings.boothId && settings.boothSecret);
  } catch (e) {
    return false;
  }
}

export async function getAppSettings(
  uuidFromUrl?: string | null | undefined
): Promise<AppSettings> {
  const defaultSettings = await getData(SETTINGS_KEYS.APP_SETTINGS);
  const mergedSettings = defaultSettings || {
    boothId: '',
    boothSecret: ''
  };

  mergedSettings.wsUrl = socketUrl();

  if (uuidFromUrl) {
    mergedSettings.boothId = uuidFromUrl;
    const secretByUUID = await getData(
      SETTINGS_KEYS.getSecretKeyByUUID(uuidFromUrl)
    );
    if (secretByUUID) {
      mergedSettings.boothSecret = secretByUUID;
    }
  }
  return mergedSettings;
}
